module.exports = __webpack_public_path__ + "assets/bpr-logo.png";